import { container } from "tsyringe";
import { useQuery } from "@tanstack/vue-query";

// entities
import { AcademyRegistrationRequestQueryKeys } from "@/entities/academy-registration-request/infrastructure/query-keys";
import { UserRepository } from "@/entities/user/models/repository";
import { UserType } from "@/entities/user/models/enums";

// features
import type { UseQueryDetailRegistrationUserProps } from "@/features/pending-registration/models/interface";

export const useQueryDetailRegistrationUser = ({
    userId,
    userType,
}: UseQueryDetailRegistrationUserProps) => {
    const userRepository = container.resolve<UserRepository>("UserRepository");

    const {
        data: userDto,
        isPending,
        error,
    } = useQuery({
        ...AcademyRegistrationRequestQueryKeys.academy_registration_user.detail(userId, userType),
        queryFn: async () => {
            const userDto =
                userType === UserType.Student
                    ? await userRepository.getAcademyStudentAllInformation(userId)
                    : await userRepository.getTeacher(userId);

            return userDto;
        },
        enabled: userId !== null && userType !== null,
        retry: false,
    });

    return {
        userDto,
        isPending,
        error,
    };
};
